import React from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import EvaluationFormula from "presentation/pages/evaluation-schemes/elements/evaluation-formula/evaluation-formula";
import { PERIOD_FORMULA_TYPE_CUSTOM, TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD, TERM_INFO_ITEM_TYPE_EVALUATION_TYPE } from "presentation/model/constants";

import { elementsToExpression } from "presentation/pages/evaluation-schemes/elements/evaluation-formula/functions";

import {
    handleFieldChange as handlePeriodFieldChange
} from 'presentation/pages/evaluation-schemes/functions/periods';


class PeriodFormulasTabEvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            terms: [],
            periodTerms: []
        };
    }

    componentDidMount() {
        this.loadTerms();
    }

    componentDidUpdate(prevProps, prevState) {
        const { periods } = this.props;
        const { periods: previousPeriodsParam } = prevProps;

        if (periods != previousPeriodsParam) {
            this.loadTerms();
        }
    }

    loadTerms = async () => {
        const { periods, evaluationTypes } = this.props;
        let periodTerms = periods.map((p, pi) => {
            return { stageId: p.stageId, id: p.id, displayName: p.name, machineName: `period:${p.id}`, isUnique: true, termInfoItemType: TERM_INFO_ITEM_TYPE_EVALUATION_PERIOD};
        });

        let terms = evaluationTypes.map((et, i) => {
            return { id: et.id, displayName: et.name, machineName: et.machineName, termInfoItemType: TERM_INFO_ITEM_TYPE_EVALUATION_TYPE}
        });

        this.setState({ terms: terms, periodTerms: periodTerms });
    }


    updateExpression = (entityKey, elements) => {
        const { component } = this.props;
        handlePeriodFieldChange(entityKey, 'formula', elements, component);
    }

    render() {
        let { component, periods } = this.props;
        let { terms, periodTerms } = this.state;
        let { updateExpression } = this;

        return (
            <Container>
                <Row>
                    <Col>
                        <h4>Fórmula dos períodos</h4>
                    </Col>
                </Row>
                {periods.map((e, i) => {
                    let isUsingPeriodTerms = parseInt(e.formulaType) == PERIOD_FORMULA_TYPE_CUSTOM;
                    let formulaTerms = isUsingPeriodTerms ? periodTerms.filter(x => x.stageId == e.stageId) : terms;
                    let existingElements = e.formula || [];
                    let periodKey = e.key;
                    return (
                        <Row key={`period-formula-${periodKey}`}>
                            <Col lg={12}><h5>{e.name}</h5></Col>
                            <Col>
                                <EvaluationFormula component={component} entityKey={periodKey} sortableKey={`ev-period-${periodKey}`} updateExpression={updateExpression} terms={formulaTerms} existingElements={existingElements} />
                            </Col>
                        </Row>
                    );
                })}

            </Container>
        );
    };
}

export default PeriodFormulasTabEvaluationSchemeForm;